module.exports = __webpack_public_path__ + "img/like.67840323.svg";